import { Outlet } from "react-router-dom";
import { SidebarContent } from "./Sidebar";
import { Header } from "./Header";
import { useAuth } from "@/context/AuthContext";

export default function AppLayout() {
  const { user } = useAuth();
  return (
    <div className="flex h-screen overflow-hidden bg-[#F5F7FA]">
      <aside className="hidden w-64 shrink-0 lg:block">
        <SidebarContent role={user?.role} />
      </aside>
      <div className="flex flex-1 flex-col overflow-hidden">
        <Header />
        <main className="flex-1 overflow-y-auto p-4 sm:p-6 lg:p-8">
          <div className="mx-auto max-w-[1400px] animate-fade-up">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
